export const leftPad = (num, char, size) => {
  const numStr = String(num);
  return numStr.length >= size
    ? numStr
    : (char.repeat(size) + numStr).substr(-size);
};

export const numberFormat = num => {
  return new Intl.NumberFormat('es-CO').format(num);
};
